import { useContext, useEffect, useState } from 'react'
import { AppContext } from '@state/context'

const useFilteredItems = (items, filterState) => {
  const [state] = useContext(AppContext)
  const [filteredItems, setFilteredItems] = useState([])
  const {
    schoolYearFilter,
    subjectFilter,
    levelFilter,
    categoryFilter,
  } = filterState ?? state?.filters

  useEffect(()=> {
    if (!items){
      setFilteredItems([])
      return
    } 

    const filtered = items.filter((item) => {
      const {
        schoolYear: { id: schoolYearId },
        subject: { id: subjectId },
        level: { id: levelId },
      } = item

      // Only books have a category, and not all of them. Sections never have
      // one, so they are filtered out when a category is selected.
      const categoryId = item.category?.id

      let allowed = true

      if (subjectFilter) {
        allowed = subjectFilter === subjectId
      }

      if (allowed && schoolYearFilter) {
        allowed = schoolYearFilter === schoolYearId
      }

      if (allowed && levelFilter) {
        allowed = levelFilter === levelId
      }

      if (allowed && categoryFilter) {
        allowed = categoryFilter === categoryId
      }

      return allowed
    })

    setFilteredItems(filtered)
  }, [items?.length, subjectFilter, schoolYearFilter, levelFilter, categoryFilter])

  return filteredItems
}

export { useFilteredItems }
